import { TextareaInputModel } from '@libs/form/models';

export const ReferenceTextInputData: TextareaInputModel = {
  type: 'textarea',
  name: 'orderCustomReferenceText',
  label: 'Rechnungstext',
  hint: '*Optional',
  attributes: {
    spellcheck: false,
    maxLength: 70,
  },
};
